import { api } from '@services';

import TagCategory, {
  ITagCategory,
  ITagCategoryApiModelWithTags,
} from '@models/TagCategory.model';
import { filterEmptyParams } from '@utils/filterEmptyParams';

export interface IRequest {
  sort?: string;
  direction?: 'ASC' | 'DESC' | undefined;
  search?: string | null;
}

const getTagsCategory = async (request: IRequest): Promise<ITagCategory[]> => {
  const search = request?.search ? request.search : '';
  const obj = {
    q: search,
    sort: request.sort,
    direction: request.direction,
  };
  const cleanParams = Object.entries(obj).filter(filterEmptyParams);
  const params = new URLSearchParams(cleanParams);

  const { data: tagCategory } = await api.get<ITagCategoryApiModelWithTags[]>(
    `/tagsCategory?${params.toString()}`,
  );

  return TagCategory.arrayFromApiModelWithTags(tagCategory);
};

export { getTagsCategory };
